import { jsx as o, Fragment as a, jsxs as m } from "react/jsx-runtime";
import { S as g } from "./index-COKuFRlK.js";
import { c as h } from "./index-DpeO8ABv.js";
import { c as f } from "./clsx-OuTLNxxd.js";
import { forwardRef as y } from "react";
import { S } from "./Spinner-ovMYPHQd.js";
import "./Button.css?__remix_sideEffect__";const _ = "320px",u = "600px",z = "1025px",q = "_isVisuallyHidden_1qq97_52",b = "_button_1qq97_64",H = "_xxSmallSize_1qq97_99",p = "_xSmallSize_1qq97_107",B = "_smallSize_1qq97_115",W = "_defaultSize_1qq97_123",v = "_largeSize_1qq97_129",k = "_primary_1qq97_137",F = "_secondary_1qq97_143",V = "_tertiary_1qq97_156",w = "_active_1qq97_170",j = "_ghost_1qq97_175",C = "_ghostBrand_1qq97_176",N = "_outline_1qq97_216",R = "_surface_1qq97_228",A = "_isFullWidth_1qq97_234",t = {
    mobile: _,
    "mobile-wide": "480px",
    tablet: u,
    "tablet-wide": "800px",
    desktop: z,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: q,
    button: b,
    xxSmallSize: H,
    xSmallSize: p,
    smallSize: B,
    defaultSize: W,
    largeSize: v,
    primary: k,
    secondary: F,
    tertiary: V,
    active: w,
    ghost: j,
    ghostBrand: C,
    outline: N,
    surface: R,
    isFullWidth: A
  },D = h(t.button, {
    variants: {
      variant: {
        default: t.primary,
        ghost: t.ghost,
        ghostBrand: t.ghostBrand,
        secondary: t.secondary,
        tertiary: t.tertiary,
        active: t.active,
        outline: t.outline,
        surface: t.surface
      },
      size: {
        "xx-small": t.xxSmallSize,
        "x-small": t.xSmallSize,
        small: t.smallSize,
        default: t.defaultSize,
        large: t.largeSize
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }),E = y(
    ({ isLoading: e, variant: i, loadingText: l, asChild: x, ...n }, s) => /* @__PURE__ */o(a, { children: e ? /* @__PURE__ */o(
        c,
        {
          ...n,
          ref: s,
          variant: i,
          "aria-busy": e,
          disabled: e,
          children: /* @__PURE__ */m(a, { children: [
            l || "Loading",
            /* @__PURE__ */o(
              S,
              {
                size: "s",
                variant: i === "secondary" ? "dark" : "light"
              }
            )]
          })
        }
      ) : /* @__PURE__ */o(c, { ...n, variant: i, ref: s, asChild: x }) })
  ),c = y(
    ({
      className: e,
      variant: i,
      size: l,
      disabled: x,
      isFullWidth: n,
      asChild: s = !1,
      ...r
    }, d) => /* @__PURE__ */o(
      s ? g : "button",
      {
        className: f(
          D({ variant: i, size: l }),
          { [t.isFullWidth]: n },
          e
        ),
        disabled: x,
        ref: d,
        "data-testid": "button-component",
        ...r
      }
    )
  );
E.displayName = "Button";
export {
  E as B,
  D as b };